import { REACT_QUERY_KEYS } from '@/constants'
import { type DcsListRequestQuery } from '@/libs/api/types'

export const dcsQueryKeys = {
  all: [REACT_QUERY_KEYS.DCS] as const,
  select: (tenantKey: string, query?: DcsListRequestQuery) =>
    [...dcsQueryKeys.all, 'select', tenantKey, query] as const,
  dispatchesResultReportSettings: (tenantKey: string, dcId: number) =>
    [
      ...dcsQueryKeys.all,
      'dispatchesResultReportSettings',
      tenantKey,
      dcId
    ] as const,
  weightDisplaySetting: (tenantKey: string, dcId: number) =>
    [...dcsQueryKeys.all, 'weightDisplaySetting', tenantKey, dcId] as const,
  siteDisplaySetting: (tenantKey: string, dcId: number) =>
    [...dcsQueryKeys.all, 'siteDisplaySetting', tenantKey, dcId] as const,
  detail: (tenantKey: string, dcId: number) =>
    [...dcsQueryKeys.all, 'detail', tenantKey, dcId] as const
}
